import styled from 'styled-components';
import { spacer16, spacer20, spacer64 } from '@spotify-internal/encore-foundation';
import { overlay, overlayArrow, typeStyleBody2 } from "../../styles";
import Overlay from "../OverlayTrigger/Overlay";

var overlayWidth = function overlayWidth(props) {
  return props.large ? '600px' : '296px';
};
/* If there is no title and a close button,
add extra padding to body text to avoid overlap */


var padding = function padding(props) {
  return props.paddedBody ? "".concat(spacer16, " ").concat(spacer64, " ").concat(spacer16, " ").concat(spacer20) : "".concat(spacer16, " ").concat(spacer20);
};

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.popover === 'dark';
};

export default styled.div.withConfig({
  displayName: "Popover",
  componentId: "ne2746-0"
})(["", ";", ";", ";padding:", ";text-transform:initial;", " &{pointer-events:all;}"], function (props) {
  return overlay({
    maxWidth: overlayWidth,
    isDarkTheme: isDarkTheme(props)
  });
}, function (props) {
  return props.arrow && overlayArrow(props.arrow, isDarkTheme(props));
}, typeStyleBody2(), padding, Overlay);